import { useCallback, useEffect, useState } from 'react';

import { ViewApiService } from '../../infrastructure/ViewApiService';

export const useGeniallyDescription = (geniallyId: string) => {
  const [geniallyDescription, setGeniallyDescription] = useState<string | undefined>(
    undefined,
  );

  const getGeniallyDescription = useCallback(async () => {
    const description = await ViewApiService.getGeniallyDescription(geniallyId);

    setGeniallyDescription(description);
  }, [geniallyId]);

  useEffect(() => {
    if (geniallyId) {
      getGeniallyDescription();
    }
  }, [geniallyId, getGeniallyDescription]);

  return geniallyDescription;
};
